module.exports = __webpack_public_path__ + "static/pr-op-planning-895353b397f44d4196e58fa829ca8ade.png";